import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface OrderStatsProps {
  isExperienced: boolean;
}

interface Stats {
  completed: number;
  pending: number;
}

export default function OrderStats({ isExperienced }: OrderStatsProps) {
  const [stats, setStats] = useState<Stats>({ completed: 2000, pending: 20 });

  useEffect(() => {
    // Initial fetch
    const fetchStats = async () => {
      try {
        const { data, error } = await supabase
          .from('order_stats')
          .select('*')
          .limit(1)
          .single();

        if (error) throw error;

        if (data) {
          setStats({
            completed: data.completed_orders,
            pending: data.pending_orders
          });
        }
      } catch (error) {
        console.error('Error loading stats:', error);
        // Fallback values if fetch fails
        setStats({
          completed: isExperienced ? 1500 : 2800,
          pending: isExperienced ? 20 : 35
        });
      }
    };

    fetchStats();

    // Subscribe to real-time changes
    const subscription = supabase
      .channel('order_stats_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'order_stats'
        },
        (payload) => {
          const newData = payload.new as any;
          setStats({
            completed: newData.completed_orders,
            pending: newData.pending_orders
          });
        }
      )
      .subscribe();

    // Cleanup subscription
    return () => {
      subscription.unsubscribe();
    };
  }, [isExperienced]);

  return (
    <div className="flex justify-center gap-8 mb-8">
      <div className="text-center">
        <div className="text-3xl font-bold text-green-600">{stats.completed}+</div>
        <div className="text-gray-600">طلب مكتمل</div>
      </div>
      <div className="text-center">
        <div className="text-3xl font-bold text-orange-500">{stats.pending}</div>
        <div className="text-gray-600">طلب في الانتظار</div>
      </div>
    </div>
  );
}